import { usePlatform } from '../contexts/platform-context';
import { Button } from './button';
import { Dialog } from './dialog';

type FeatureBlockedModalProps = {
  isOpen: boolean;
  onClose: () => void;
  featureName: string;
  targetPath?: string; // Optional path to open in web app (e.g., '/settings?panel=billing')
};

export const FeatureBlockedModal = ({
  isOpen,
  onClose,
  featureName,
  targetPath = '',
}: FeatureBlockedModalProps) => {
  const { webAppUrl } = usePlatform();

  const handleOpenInWebApp = () => {
    const fullUrl = `${webAppUrl}${targetPath}`;
    window.open(fullUrl, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      aria-labelledby="feature-blocked-title"
      className="flex flex-col overflow-hidden"
    >
      {/* Header with Icon */}
      <div className="flex flex-col items-center p-6 border-b border-border/30">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
          <svg
            className="w-6 h-6 text-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </div>

        <h2 id="feature-blocked-title" className="text-lg font-semibold text-foreground text-center">
          {featureName} Not Available in Sidebar
        </h2>
      </div>

      {/* Content */}
      <div className="p-6">
        <p className="text-sm text-muted-foreground text-center leading-relaxed">
          This feature requires more space and is only accessible in the full web app. Would you
          like to open it in a new tab?
        </p>
      </div>

      {/* Footer with Buttons */}
      <div className="flex flex-col gap-3 p-6 border-t border-border/30">
        <Button onClick={handleOpenInWebApp} variant="primary" className="w-full">
          Open in Web App →
        </Button>
        <Button onClick={onClose} variant="secondary" className="w-full">
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};
